import { useState, useEffect } from 'react';
import { ethers, formatEther, parseEther } from 'ethers';
import Button from 'react-bootstrap/Button';
import ABI from './abi.json';
import './App.css';

const CONTRACT_ADDRESS = "0x46315752379E5D87EB58804e2Bde9CA5DC6Aa4ee";

function App() {
    const [depositAmount, setDepositAmount] = useState("");
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [withdrawAddress, setWithdrawAddress] = useState("");
    const [depositorAddress, setDepositorAddress] = useState("");
    const [error, setError] = useState("");
    const [depositorBalance, setDepositorBalance] = useState("0");
    const [BNBFee, setBNBFee] = useState("");
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        const connectWallet = async () => {
            try {
                const provider = await getProvider();
                const accounts = await provider.send("eth_accounts", []);
                if (accounts && accounts.length > 0) {
                    setDepositorAddress(accounts[0]);
                    setIsConnected(true);
                }
            } catch (err) {
                console.error(err.message);
            }
        };

        connectWallet();
        fetchBNBFee();
        const interval = setInterval(fetchBNBFee, 15000);

        return () => clearInterval(interval);
    }, []);

    async function fetchBNBFee() {
        try {
            const provider = await getProvider();
            const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, provider);
            const fee = await contract.BNBFee();
            setBNBFee(formatEther(fee));
        } catch (err) {
            setError(err.message);
        }
    }

    useEffect(() => {
        if (depositorAddress) {
            fetchDepositorBalance();
        }
    }, [depositorAddress]);

    async function fetchDepositorBalance() {
        try {
            const provider = await getProvider();
            const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, provider);
            const balance = await contract.checkDepositorBalance(depositorAddress);
            setDepositorBalance(formatEther(balance) || "0");
        } catch (err) {
            setError(err.message);
        }
    }

    async function getProvider() {
        if (!window.ethereum) throw new Error(`No MetaMask found!`);
        const provider = new ethers.BrowserProvider(window.ethereum);
        return provider;
    }

    async function connectWallet() {
        try {
            const provider = await getProvider();
            const newAccounts = await provider.send("eth_requestAccounts", []);
            if (newAccounts && newAccounts.length) {
                setDepositorAddress(newAccounts[0]);
                setIsConnected(true);
            }
        } catch (err) {
            setError(err.message);
        }
    }

    async function disconnectWallet() {
        setDepositorAddress("");
        setDepositorBalance("0");
        setIsConnected(false);
    }

    async function depositBNB() {
        try {
            if (!isConnected) throw new Error('Please connect your wallet first.');

            const provider = await getProvider();
            const signer = await provider.getSigner();
            const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, signer);

            const tx = await contract.depositBNB({ value: parseEther(depositAmount) });
            await tx.wait();
            alert(`Deposit Successful: ${tx.hash}`);
            setDepositAmount("");
            fetchDepositorBalance();
            fetchBNBFee();
        } catch (err) {
            setError(err.message);
        }
    }

    async function withdrawBNB() {
        try {
            if (!isConnected) throw new Error('Please connect your wallet first.');
            if (!withdrawAmount) {
                setError('Withdrawal amount cannot be empty!');
                return;
            }

            if (!withdrawAddress) {
                setError('Withdraw address cannot be empty!');
                return;
            }

            const amountInWei = parseEther(withdrawAmount);
            const balanceInWei = ethers.parseEther(depositorBalance || "0");

            if (amountInWei > balanceInWei) {
                setError('Withdrawal amount exceeds balance!');
                return;
            }

            const provider = await getProvider();
            const signer = await provider.getSigner();
            const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, signer);

            const depositors = [withdrawAddress];
            const tx = await contract.withdrawBNB(amountInWei, depositors);
            await tx.wait();
            alert(`Withdrawal Successful: ${tx.hash}`);
            setWithdrawAmount("");
            setWithdrawAddress("");
            fetchDepositorBalance();
            fetchBNBFee();
        } catch (err) {
            console.error("Error during withdrawal:", err);
            setError(err.message);
        }
    }

    const buttonStyle = {
        fontSize: '1em',
        padding: '10px 20px',
        minWidth: '120px',
        height: '45px',
        backgroundColor: '#333333',
        color: '#33FF33',
        border: '1px solid #33FF33',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s, transform 0.3s',
        marginTop: '20px',
    };

    const buttonHoverEffect = (e) => {
        e.target.style.backgroundColor = '#28a745';
        e.target.style.transform = 'scale(1.05)';
    };

    const buttonHoverOutEffect = (e) => {
        e.target.style.backgroundColor = '#333333';
        e.target.style.transform = 'scale(1)';
    };

    return (
        <div style={{ backgroundColor: '#000000', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{
                backgroundColor: '#000000',
                borderRadius: '15px',
                padding: '30px',
                boxShadow: '0px 0px 15px 5px #33FF33',
                width: '90%',
                height: '85%',
                fontFamily: "'Courier New', Courier, monospace",
                color: '#33FF33',
                fontSize: '1.2em',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                position: 'relative',
                border: '3px solid #33FF33'
            }}>
                {/* Connect Wallet Button moved to the top */}
                <header style={{ position: 'absolute', top: '20px', right: '20px' }}>
                    <button
                        onClick={isConnected ? disconnectWallet : connectWallet}
                        style={buttonStyle}
                        onMouseEnter={buttonHoverEffect}
                        onMouseLeave={buttonHoverOutEffect}
                    >
                        {isConnected ? 'Disconnect' : 'Connect Wallet'}
                    </button>
                </header>

                <header style={{ position: 'absolute', top: '20px', left: '20px', fontSize: '1.5em', fontWeight: 'bold' }}>
                    <span style={{ color: '#33FF33', textShadow: '0px 0px 8px #33FF33' }}>Super Vault on Base</span>
                </header>

                <main style={{ textAlign: 'center', marginTop: '70px' }}>
                    <div style={{ margin: '20px 0' }}>
                        <label style={{ color: '#33FF33', fontSize: '1.2em' }}>BNB Fee: {BNBFee} </label>
                    </div>
                    <div style={{ margin: '20px 0' }}>
                        <label style={{ color: '#33FF33', fontSize: '1.2em' }}>Depositor Balance: {depositorBalance} BNB</label>
                    </div>
                    <div style={{ margin: '20px 0' }}>
                        <label style={{ color: '#33FF33', fontSize: '1.2em' }}>Deposit BNB:
                            <input type="text" value={depositAmount} onChange={(evt) => setDepositAmount(evt.target.value)} style={{ marginLeft: '10px', padding: '8px', width: '200px', backgroundColor: '#000000', color: '#33FF33', border: '1px solid #33FF33', fontSize: '1em' }} />
                        </label>
                        <Button
                            onClick={depositBNB}
                            style={buttonStyle}
                            onMouseEnter={buttonHoverEffect}
                            onMouseLeave={buttonHoverOutEffect}
                        >
                            Deposit
                        </Button>
                    </div>
                    <div style={{ margin: '20px 0' }}>
                        <label style={{ color: '#33FF33', fontSize: '1.2em' }}>Withdraw BNB:
                            <input type="text" value={withdrawAmount} onChange={(evt) => setWithdrawAmount(evt.target.value)} style={{ marginLeft: '10px', padding: '8px', width: '200px', backgroundColor: '#000000', color: '#33FF33', border: '1px solid #33FF33', fontSize: '1em' }} />
                            <input type="text" value={withdrawAddress} onChange={(evt) => setWithdrawAddress(evt.target.value)} placeholder="Withdrawer Address" style={{ marginLeft: '10px', padding: '8px', width: '200px', backgroundColor: '#000000', color: '#33FF33', border: '1px solid #33FF33', fontSize: '0.9em' }} />
                        </label>
                        <Button
                            onClick={withdrawBNB}
                            style={buttonStyle}
                            onMouseEnter={buttonHoverEffect}
                            onMouseLeave={buttonHoverOutEffect}
                        >
                            Withdraw
                        </Button>
                    </div>
                    {error && <div style={{ color: 'red', fontSize: '1em' }}>{error}</div>}
                </main>

                {/* Footer Section */}
                <footer style={{
                    marginTop: '30px',
                    color: '#33FF33',
                    fontSize: '0.8em',
                    textAlign: 'center',
                }}>
                    <p>Copyright&copy; 2024 - SUPER VAULT - All Rights Reserved.</p>
                    <p>Contact: support@supervault.fun</p>
                </footer>
            </div>
        </div>
    );
}

export default App;
